import { FC } from "react";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";
import { useAppSelector } from "@/store/hooks";

import { CostAllocationMetadataInCategoryEditTableRow } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/metadata-in-category-edit/CostAllocationMetadataInCategoryEditTableRow";

export const CostAllocationMetadataInCategoryEdit: FC = () => {
  const sharedCosts = useAppSelector(dimensionSharedCostsSelector);

  return (
    <Stack
      p={1}
      bgcolor="grey.100"
      borderRadius={3}
      direction="row"
      spacing={1}
    >
      <CurrencyExchangeOutlinedIcon color="action" fontSize="small" />

      <Stack spacing={1} width="100%">
        <Typography variant="body2">
          This category includes shared costs, as its Dimension has a cost
          allocation rule applied. Please review the allocation if needed.
        </Typography>

        <Box sx={tableWrapperStyles}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Allocation Rule Name</TableCell>
                <TableCell>Allocation (%)</TableCell>
                <TableCell>Allocation Type</TableCell>
                <TableCell>Scope</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {sharedCosts.map((sharedCost) => {
                return (
                  <CostAllocationMetadataInCategoryEditTableRow
                    sharedCost={sharedCost}
                    key={sharedCost.id}
                  />
                );
              })}
            </TableBody>
          </Table>
        </Box>
      </Stack>
    </Stack>
  );
};

const tableWrapperStyles = {
  border: 1,
  borderBottom: 0,
  borderColor: "grey.300",
  bgcolor: "white",
  borderRadius: 3,
  overflow: "hidden",
  th: { fontWeight: "medium", bgcolor: "grey.50", p: 1, whiteSpace: "nowrap" },
};
